// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","white":"#ffffff","grey-lighter":"#e9e9e9","logo_block":"_236ZLlE","image":"_2U9gOaz"};